import { Dimensions, Platform, StyleSheet } from 'react-native'

import { isIPhoneDeviceWithNotch } from '../../../Utils/Platform';
import { Fonts, Colors } from '../../Themes';

const isIPhoneWithNotch = isIPhoneDeviceWithNotch();

export default StyleSheet.create({
  containerStyle: {
    flex: 1,
  },
  imageContainerStyle: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  textContainerStyle: {
    flex: 1,
    alignItems: 'center',
    marginHorizontal: 40,
  },
  titleTextStyle: {
    fontSize: 28,
    ...Fonts.type.bold,
    color: Colors.blackTwo,
    marginTop: 32,
    marginBottom: 16,
  },
  descriptionTextStyle: {
    fontSize: 16,
    textAlign: 'center',
    color: Colors.blackTwo,
    lineHeight: 22,
  },
  buttonStyle: {
    marginBottom: isIPhoneWithNotch ? 45 : 0,
    marginHorizontal: 16,
    marginTop: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 32 : 0
  },
});
